import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { PlanFormService } from '../../services';
import { BaseComponent, ConfirmationComponent } from '../../shared';
import { PlanDataComponent } from '../plan-data';
import { PlanOverviewComponent } from '../plan-overview';
import { PlanSetupComponent } from '../plan-setup';


/**
 * Plan creation/editing page component.
 */
@Component({
	selector: 'app-plan',
	templateUrl: './plan.component.html',
	imports: [
		NgbNavModule,
		NgTemplateOutlet,
		PlanDataComponent,
		PlanSetupComponent,
		PlanOverviewComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlanComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly modalSrv = inject(NgbModal);
	private readonly route = inject(ActivatedRoute);
	protected planFormSrv = inject(PlanFormService);


	ngOnInit(): void {
		this.planFormSrv.initForm(this.route).subscribe();
	}

	get isWarningVisible(): boolean { return this.isResetAnalysisWngVisible || this.isResetImagesWngVisible; }
	get isResetAnalysisWngVisible(): boolean { return this.planFormSrv.isResetAnalysisWarning; }
	get isResetImagesWngVisible(): boolean { return this.planFormSrv.isRingCalibrationInvalid; }
	get isArrowsVisible(): boolean { return !this.modalSrv.hasOpenModals(); }

	/**
	 * Handle back button click.
	 */
	back(): void {
		if (this.planFormSrv.isFormDirty) {
			this.openConfirmModal();
		} else {
			this.planFormSrv.returnToPatientList();
		}
	}

	/**
	* Open confirmation modal before navigate to previous page.
	*/
	private openConfirmModal(): void {
		if (!this.modalSrv.hasOpenModals()) {
			const modalRef = this.modalSrv.open(ConfirmationComponent, { centered: true, backdrop: 'static' });
			(modalRef.componentInstance as ConfirmationComponent).config = {
				title: this.labels().PLAN_CREATION_COMPONENT_CANCEL_MODAL_TITLE,
				message: this.labels().PLAN_CREATION_COMPONENT_CANCEL_MODAL_MESSAGE,
				cancelBtn: this.labels().PLAN_CREATION_COMPONENT_CANCEL_MODAL_NO,
				confirmBtn: this.labels().PLAN_CREATION_COMPONENT_CANCEL_MODAL_YES
			};
			modalRef.result.then(() => this.planFormSrv.returnToPatientList()).catch(error => false);
		}
	}


	/**
	 * Navigate to previous plan form tab.
	 */
	prev(): void {
		this.planFormSrv.nextTab({ activeId: this.planFormSrv.activeTab, nextId: this.planFormSrv.activeTab - 1, preventDefault: () => { } });
	}

	/**
	 * Navigate to next plan form tab.
	 */
	next(): void {
		this.planFormSrv.nextTab({ activeId: this.planFormSrv.activeTab, nextId: this.planFormSrv.activeTab + 1, preventDefault: () => { } });
	}


	ngOnDestroy(): void {
		this.planFormSrv.reset();
	}
}
